import React from 'react';
import c from '../../constants';
import LinePreview from './linePreview';
import RestPreview from './restPreview';

type Props = {
  fieldPreviewType: string,
  zoom: number,
  fieldPreviewStart: {
    x: number,
    y: number,
  },
  fieldPreviewEnd: {
    x: number,
    y: number,
  }
}

const FieldPreview = ({
  fieldPreviewType, zoom, fieldPreviewStart, fieldPreviewEnd,
}: Props) => {
  const x = fieldPreviewStart.x < fieldPreviewEnd.x ? fieldPreviewStart.x : fieldPreviewEnd.x;
  const y = fieldPreviewStart.y < fieldPreviewEnd.y ? fieldPreviewStart.y : fieldPreviewEnd.y;
  const width = Math.abs(fieldPreviewStart.x - fieldPreviewEnd.x);
  const height = Math.abs(fieldPreviewStart.y - fieldPreviewEnd.y);

  switch (fieldPreviewType) {
    case c.ItemTypes.LINE: {
      return (
        <LinePreview
          zoom={zoom}
          x1={fieldPreviewStart.x}
          y1={fieldPreviewStart.y}
          x2={fieldPreviewEnd.x}
          y2={fieldPreviewEnd.y}
        />
      );
    }
    default: {
      return (
        <RestPreview
          x={x}
          y={y}
          width={width}
          height={height}
          zoom={zoom}
        />
      );
    }
  }
};

export default FieldPreview;
